import { HTTP } from '@/api/http-common'

export default {
  getCategoryList (callback, param) {
    HTTP.get('shop/' + param.publicKey + '/category?category_id=' + param.categoryId).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getCategorySelected (callback, param) {
    HTTP.get('shop/' + param.publicKey + '/category/' + param.categoryId).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        console.log('Error: authentication fail')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}
